import React, {FC} from 'react';

import {TransientAccountDetailsContainer} from '../../../../../../../../src/components/accounts/accountDetails/accountDetailsContainer';
import {ContactsManagerParametersTypesEnum} from '../../../../../../../../src/store/panels/contacts/contactsManager/parameters/contactsManagerParameters';
import {
  ContactsManagerPanelId,
  makeAccountDetailsPanelId,
} from '../../../../../../../../src/store/panels/panelStateBase';
import {useConstant} from '../../../../../../../../srcCommon/helpers/hookHelpers';
import {accountsManagerAccountDetailsTrackingHandler} from '../../helpers/accountsManagerAccountDetailsTracking';

/*
 * Props.
 */

interface AccountDetailsSidePanelProps {
  panelId: ContactsManagerPanelId;
  accountId?: number;
  location?: ContactsManagerParametersTypesEnum;
}

/*
 * Component.
 */

export const AccountDetailsSidePanel: FC<AccountDetailsSidePanelProps> = (props) => {
  const {panelId, accountId, location} = props;
  const accountDetailsPanelId = useConstant(() => makeAccountDetailsPanelId(panelId));

  if (!accountId) {
    return null;
  }
  return (
    <TransientAccountDetailsContainer
      panelId={accountDetailsPanelId}
      accountId={accountId}
      location={location}
      onTrackEvent={accountsManagerAccountDetailsTrackingHandler}
    />
  );
};
